import { GATEWAY, buidlURL, fetchRequest } from '../../api';
import Vue from 'vue';

const state = {
  hotel: null,
  loading: false,
  error: false,
  errors: [],
  errorMessage: '',
  rooms: [],
  roomGroups: [],
  roomsDone: [],
  reviews: [],
  hotelWaitingRooms: false,
  wait: {
    hotel: 'Подождите, идет загрузка отеля',
    reviews: 'Подождите, идет загрузка отзывов об отеле',
    rooms: 'Подождите, идет актуализация тарифов в отель'
  },
  errorList: {
    getHotelReviews: 'Не получилось загрузить отзывы: getHotelReviews error',
    getAvailableRooms: 'Не получилось загрузить номера: getAvailableRooms error'
  }
};

const getters = {};
const actions = {
  collect({ state, commit, dispatch }, hotel) {
    commit('updateHotel', hotel);
    commit('setLoading', state.wait.hotel, { root: true });
    dispatch('getLocation', null, { root: true });
  },
  getHotelReviews({ state, commit }, query) {
    commit('setLoading', state.wait.reviews, { root: true });

    const url = buidlURL(GATEWAY, {
      type: 'hotelreviews',
      ...query
    });

    fetchRequest(
      url,
      response => {
        if (response.error)
          return commit('throwError', state.errorList.getHotelReviews);

        commit('updateHotelReviews', response.result);
        commit('setLoading', state.wait.reviews, { root: true });
      },
      () => {
        commit('throwError', state.errorList.getHotelReviews);
      }
    );
  },
  getAvailableRooms({ state, commit }, query) {
    commit('setLoading', state.wait.rooms, { root: true });
    commit('setRoomsDone');

    const url = buidlURL(GATEWAY, {
      type: 'actualize_sync',
      ...query
    });
    fetchRequest(
      url,
      response => {
        if (response.error)
          return commit('throwError', state.errorList.getAvailableRooms);

        commit(
          'addAvailableRooms',
          response.result.hotels[0] ? response.result.hotels[0].rates : []
        );
        commit('setHotelWaitingRooms', false);
        setTimeout(
          () => commit('setLoading', state.wait.rooms, { root: true }),
          1000
        );
      },
      () => {
        commit('throwError', state.errorList.getAvailableRooms);
      }
    );
  }
};
const mutations = {
  clearHotelReviews(state) {
    state.reviews = [];
  },
  updateHotelReviews(state, reviews) {
    state.reviews = [];
    state.reviews.push(...reviews);
  },
  throwError(state, reason) {
    state.error = true;
    state.errors.push(reason);
    // eslint-disable-next-line
    console.log(reason, state.errors);
  },
  updateHotel(state, hotel) {
    state.hotel = hotel;
  },
  clearAvailableRooms(state) {
    state.roomGroups = [];
    state.rooms = [];
  },
  addAvailableRooms(state, rooms) {
    const hashList = state.rooms.map(room => room.availability_hash);
    state.rooms.push(
      ...rooms.filter(room => !hashList.includes(room.availability_hash))
    );
    state.rooms.sort(
      (a, b) => parseFloat(a.rate_price) - parseFloat(b.rate_price)
    );
  },
  // setLoading(state, loadingMessage) {
  //   state.error = false;
  //   state.loading = state.loading !== loadingMessage;
  //   // state.loadingMessage = loadingMessage;
  // },
  // unsetLoading(state, loadingMessage) {
  //   state.error = false;
  //   state.loading = false;
  //   // state.loadingMessage = loadingMessage;
  // },
  setHotelWaitingRooms(state, value = true) {
    state.hotelWaitingRooms = value;
  },
  updateRoomsInfo(state) {
    state.rooms.forEach(room => {
      if (room.info) return;
      const info = state.hotel.info.room_groups.find(
        group => group.room_group_id === room.room_group_id
      );
      Vue.set(room, 'info', info);
    });
  },
  setRoomsDone(state, page) {
    if (!page) state.roomsDone = [];
    else state.roomsDone.push(page);
  },
  updateRoomGroups(state) {
    state.roomGroups = state.rooms.reduce((acc, item) => {
      if (!acc.find(group => group.room_group_id === item.room_group_id))
        acc.push({
          room_group_id: item.room_group_id,
          info: state.hotel.info.room_groups.find(
            group => group.room_group_id === item.room_group_id
          ),
          rooms: []
        });
      const group = acc.find(
        group => group.room_group_id === item.room_group_id
      );
      group.rooms.push(item);
      return acc;
    }, []);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
